import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { VehicleOdometerChangeReasonEnum } from '../enums/vehicle-odometer-change-reason.enum';

/**
 * Create vehicle odometer tracking DTO
 */
export class CreateVehicleOdometerTrackingDto {
  sourceSubject!: AppSubjectEnum;
  @TransformInt()
  sourceId!: number;
  changeReason!: VehicleOdometerChangeReasonEnum;
  @TransformInt()
  changeReferenceId?: number;
  notes?: string | null;
  @TransformInt()
  vehicleId!: number;
  @TransformInt()
  value!: number;
  @TransformDate()
  recordedAt!: Date;
}
